export const parseViewConfigParam = (raw: string | null): unknown | null => {
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(decodeURIComponent(raw));
  } catch {
    return null;
  }
};
